import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { useLang } from "@/common/Contexts/LanguageContext";
import { PageNamesEnum } from "@/routes/routes";
import stl from "./SeoLandingIndexPage.module.css";
var SeoLandingIndexPage = function SeoLandingIndexPage() {
  var _data$pages;
  var _useTranslation = useTranslation(["web_footer"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var lang = useLang();
  var data = useFullPageData(PageNamesEnum.PAGE_NAME__SeoLandingIndex);
  if (!data) return null;
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    linksForSearch: true,
    authenticationMsg: true
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("h1", {
    className: stl.heading
  }, t("support_pages", {
    ns: "web_footer"
  })), /*#__PURE__*/React.createElement("ul", {
    className: stl.list
  }, (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.map(function (page) {
    return /*#__PURE__*/React.createElement("li", {
      key: page.id
    }, /*#__PURE__*/React.createElement("a", {
      href: createUrl("/landing/".concat(page.slug))
    }, lang === "en" ? page.title_en : page.title_ar));
  }))));
};
export default SeoLandingIndexPage;